import AdminService from '@/services/AdminService'
import Admin from '@/types/Admin'
import Producer from '@/types/Producer'
import { DateTime } from 'luxon'
import { computed, ref, watch } from 'vue'

export function useAdminFilter(producer: Producer) {
  const loading = ref(false)

  const expires = ref<DateTime>()

  const items = ref<Admin[]>([])

  const load = async () => {
    loading.value = true

    const service = new AdminService()

    const response = await service.index(1, `producer_id=${producer.id}`, 100)

    items.value = response.data.data

    expires.value = DateTime.now().plus({ minutes: 5 })

    loading.value = false
  }

  watch(producer, () => load(), { immediate: true })

  return {
    items: computed(
      () => {
        if (expires.value !== undefined && DateTime.now() > expires.value) {
          load()
        }

        return items.value
      },
    ),
    loading,
  }
}
